import * as React from 'react';
import { ILxsContactViewProps } from './lxs-contact';

export default (props: ILxsContactViewProps) => {
    let trimmedTelephoneNumber = '';
    if (props.config.telephoneNumber && typeof props.config.telephoneNumber === 'string') {
        // Remove all spaces from the phone number
        trimmedTelephoneNumber = props.config.telephoneNumber.replace(/\s/g, '');
    }
    return (
        <div className='lxs-contact'>
            <div className='lxs-contact__title'>{props.config.title}</div>
            <h3 className='lxs-contact__name'>{props.config.name}</h3>
            <p className='lxs-contact__position'>{props.config.position}</p>
            <div className='lxs-contact__banner-bottom'>
                <div className='lxs-contact__phonenumber'>
                    <span>
                        <a href={`tel:${trimmedTelephoneNumber}`}>{props.config.telephoneNumber}</a>
                    </span>
                </div>

                {props.config.emailAddress && (
                    <a className='lxs-contact__link msc-cta__secondary' href={`mailto:${props.config.emailAddress}`}>
                        {props.resources.contactSendMessageButtonLabel}
                    </a>
                )}
            </div>
        </div>
    );
};
